module.exports = __webpack_public_path__ + "img/coupon-runout-custom.e7e6391c.png";